var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_12511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50054 18.9991C14.4558 18.9991 18.4728 14.9821 18.4728 10.0269C18.4728 5.07169 14.4558 1.05469 9.50054 1.05469C4.54532 1.05469 0.52832 5.07169 0.52832 10.0269C0.52832 14.9821 4.54532 18.9991 9.50054 18.9991Z",
    fill: "#F4900C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50054 17.9444C14.4558 17.9444 18.4728 13.9274 18.4728 8.97222C18.4728 4.017 14.4558 0 9.50054 0C4.54532 0 0.52832 4.017 0.52832 8.97222C0.52832 13.9274 4.54532 17.9444 9.50054 17.9444Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50022 16.8891C13.581 16.8891 16.8891 13.581 16.8891 9.50022C16.8891 5.41945 13.581 2.11133 9.50022 2.11133C5.41945 2.11133 2.11133 5.41945 2.11133 9.50022C2.11133 13.581 5.41945 16.8891 9.50022 16.8891Z",
    fill: "#FFE8B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38889 16.7778C13.4697 16.7778 16.7778 13.4697 16.7778 9.38889C16.7778 5.30812 13.4697 2 9.38889 2C5.30812 2 2 5.30812 2 9.38889C2 13.4697 5.30812 16.7778 9.38889 16.7778Z",
    fill: "#FFAC33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49991 4.4043C9.49991 4.4043 6.62089 5.76121 6.33377 5.88366C6.04614 6.00557 6.14219 6.20613 6.3343 6.20613H12.6518C12.9484 6.20613 12.8782 5.97971 12.6428 5.85727C12.4074 5.73535 9.49991 4.4043 9.49991 4.4043Z",
    fill: "#FFAC33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_12511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.d152cdd841ef7971fe6c41321a5bfc92.svg";
export { ForwardRef as ReactComponent };